import { render, staticRenderFns } from "./custom-business-184.vue?vue&type=template&id=8464baf4&scoped=true"
import script from "./custom-business-184.vue?vue&type=script&lang=js"
export * from "./custom-business-184.vue?vue&type=script&lang=js"
import style0 from "./custom-business-184.vue?vue&type=style&index=0&id=8464baf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8464baf4",
  null
  
)

export default component.exports